// Redux Slice for AI Service
import axiosInstance from "./axios.instance";

export const API_WHITELABEL_COMPANY = async (formData) => {
  try {
    const response = await axiosInstance.post("admin/company/whitelabel", formData);
    return response.data;
  } catch (error) {
    console.log("Error in API_WHITELABEL_COMPANY:", error);
    throw error;
  }
};


export const API_GET_WHITELABEL_COMPANY = async (companyId) => {
  try {
    const response = await axiosInstance.get(`admin/company/${companyId}/whitelabel`);
    return response.data;
  } catch (error) {
    console.log("Error in API_GET_WHITELABEL_COMPANY:", error);
    throw error;
  }
};
